export default __webpack_public_path__ + "static/media/Print-13.cf3dfa1c.svg";